import script from "./FooterBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterBlock.vue?vue&type=script&setup=true&lang=js"

import "./FooterBlock.vue?vue&type=style&index=0&id=27b37ea3&lang=css"

const __exports__ = script;

export default __exports__